import mendeleev from "@/urls/mendeleev"
import {
  sendGetRequest, sendPatchRequest, sendPostRequest, sendPostRequestFile, sendPutRequest,
} from "@/helper/requests"
import schoolchild from "@/store/modules/personal_account/members/schoolchild"
import student from "@/store/modules/personal_account/members/student"
import science from "@/store/modules/personal_account/members/science"
import agreements from "@/store/modules/personal_account/members/agreements"
import cards from "@/store/modules/personal_account/members/cards"
import postgraduate from "@/store/modules/personal_account/members/postgraduate"

const state = {
  members: {
    currentUrl: null,
    items: null,
    previous_member: null,
    loading: false,
    count: 0,
    detail: [],
    next: null,
    prev: null,
    error: null,
  }
}

const getters = {
  getMembers: state => state.members.items,
  getPreviousMembers: state => state.members.previous_member,
  getMembersCount: state => state.members.count,
  getMembersCurrentUrl: state => state.members.currentUrl,
  getMembersNext: state => state.members.next,
  getMembersPrev: state => state.members.prev,
  getMembersDetail: state => state.members.detail,
  isLoadingMembers: state => state.members.loading,
  saveMembersError: state => state.members.error,
}

const actions = {
  loadMembers: ({ commit, getters }, { finalizer = () => {}, catcher = () => {} }) => {
    const url = mendeleev.USER.MEMBER.LIST()
    if (!getters.isLoadingMembers) {
      commit('SET_MEMBERS_LOADING')
      sendGetRequest(
        url, (data, url) => {
          commit('SET_MEMBERS', data)
          commit('SET_MEMBERS_LOADING_END')
          finalizer(data, url)
        }, (data, url) => {
          commit('SET_MEMBERS_LOADING_END')
          commit('SAVE_MEMBERS_ERROR', data)
          catcher(data, url)
        }
      )
    }
  },
  loadPreviousMembers: ({ commit, getters }, { finalizer = () => {}, catcher = () => {} }) => {
    const url = mendeleev.USER.MEMBER.PREVIOUS()
    sendGetRequest(
      url, (data, url) => {
        commit('SET_PREVIOUS_MEMBERS', data)
        finalizer(data, url)
      }, (data, url) => {
        commit('SAVE_MEMBERS_ERROR', data)
        catcher(data, url)
      }
    )
  },
  createMember: ({ commit }, { data, finalizer = () => {}, catcher = () => {} }) => {
    const url = mendeleev.USER.MEMBER.CREATE()
    commit('SET_MEMBERS_LOADING')
    sendPostRequest(
      url, data, (data, url) => {
        commit('SET_MEMBERS_LOADING_END')
        finalizer(data, url)
      }, (data, url) => {
        commit('SET_MEMBERS_LOADING_END')
        catcher(data, url)
      }
    )
  },
  updateMember: ({ commit }, { id, data, finalizer = () => {}, catcher = () => {} }) => {
    const url = mendeleev.USER.MEMBER.UPDATE(id)
    commit('SET_MEMBERS_LOADING')
    sendPutRequest(
      url, data, (data, url) => {
        commit('SET_MEMBERS_LOADING_END')
        finalizer(data, url)
      }, (data, url) => {
        commit('SET_MEMBERS_LOADING_END')
        catcher(data, url)
      }
    )
  },
  changeMailings: ({ commit }, { data, finalizer = () => {}, catcher = () => {} }) => {
    const url = mendeleev.USER.MEMBER.CHANGE_MAILING()
    commit('SET_MEMBERS_LOADING')
    sendPatchRequest(
      url, data, (data, url) => {
        commit('SET_MEMBERS_LOADING_END')
        finalizer(data, url)
      }, (data, url) => {
        commit('SET_MEMBERS_LOADING_END')
        catcher(data, url)
      }
    )
  },
  resendMailings: ({ commit }, { finalizer = () => {}, catcher = () => {} }) => {
    const url = mendeleev.USER.MEMBER.RESEND_MAILING()
    commit('SET_MEMBERS_LOADING')
    sendGetRequest(
      url, (data, url) => {
        commit('SET_MEMBERS_LOADING_END')
        finalizer(data, url)
      }, (data, url) => {
        commit('SET_MEMBERS_LOADING_END')
        catcher(data, url)
      }
    )
  },
  // loadMembersDetail: ({commit}, {url, id, finalizer=()=>{}, catcher=()=>{}}) => {
  //   if (!url) url = url = mendeleev.USER.MEMBERS.MEMBERS.DETAIL(id)
  //   sendGetRequest(
  //     url, (data, url) => {
  //       commit('SET_MEMBERS_DETAIL', data);
  //       finalizer(data, url);
  //     }, (data, url) => {
  //       commit('SAVE_MEMBERS_ERROR', data);
  //       catcher(data, url);
  //     }
  //   )
  // },
  memberApplicationUpdate: ({ commit }, { data, finalizer = () => {}, catcher = () => {} }) => {
    const url = mendeleev.USER.MEMBER.APPLICATION.UPDATE()
    commit('SET_MEMBERS_LOADING')
    sendPostRequestFile(
      url, data, (data, url) => {
        commit('SET_MEMBERS_LOADING_END')
        finalizer(data, url)
      }, (data, url) => {
        commit('SET_MEMBERS_LOADING_END')
        catcher(data, url)
      }
    )
  },
}

const mutations = {
  SET_MEMBERS: (state, value) => {
    state.members.items = value
  },
  SET_PREVIOUS_MEMBERS: (state, value) => {
    state.members.previous_member = value
  },
  SET_MEMBERS_DETAIL: (state, value) => {
    state.members.detail = value
  },
  SET_MEMBERS_COUNT: (state, value) => {
    state.members.count = value
  },
  SET_MEMBERS_CURRENT_URL: (state, value) => {
    state.members.currentUrl = value
  },
  SET_MEMBERS_NEXT_URL: (state, value) => {
    state.members.next = value
  },
  SET_MEMBERS_PREV_URL: (state, value) => {
    state.members.prev = value
  },
  SET_MEMBERS_LOADING: (state) => {
    state.members.loading = true
  },
  SET_MEMBERS_LOADING_END: (state) => {
    state.members.loading = false
  },
  SAVE_MEMBERS_ERROR: (state, error) => {
    state.members.error = error
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
  modules: {
    schoolchild: schoolchild,
    student: student,
    science: science,
    postgraduate: postgraduate,
    agreements: agreements,
    cards: cards
  }
}
